// src/components/DropDownArea.jsx
import React, { useEffect, useState } from "react";
import { apiFetch } from "../utils/wkCommon";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AreaLookup({ value, onChange, onSelectOption, placeholder = "-- pilih Area --", disabled = false, showLabel = false }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState(""); // optional: search text

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      try {
        // ambil maksimal 200 item; sesuaikan pagination jika banyak data
        const path = `/api/areas?pagination[pageSize]=200&fields%5B%5D=name&fields%5B%5D=shortname&sort%5B0%5D=name%3Aasc`;
        const data = await apiFetch(path);
        // apiFetch di project mengembalikan parsed json
        // Strapi v5 typical: { data: [ { id, attributes: { name } }, ... ] }
        const arr = data?.data ?? [];
        if (!mounted) return;
        setOptions(arr.map(a => ({ id: a.id, name: a.name ?? "", shortname: a.shortname ?? "" })));
      } catch (err) {
        console.error("AreaLookup fetch error:", err);
        setOptions([]);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => (mounted = false);
  }, []);

  return (
    <div style={{ marginBottom: "0.75rem" }}>
      { showLabel && ( <label style={{ display: "block", marginBottom: "0.375rem", color: "#2b4a84", fontWeight: 600 }}>Area</label> )}
      <select
        name="area"
        value={value ?? ""}
        onChange={(e) => {
          const raw = e.target.value;
          const id = raw ? (Number(raw) || raw) : null;
          // call original onChange with id (backwards compatible)
          onChange && onChange(id);
            // also call onSelectOption with full option object (if provided)
            const opt = options.find(o => String(o.id) === String(id)) ?? null;
            if (typeof onSelectOption === "function") onSelectOption(opt);
          }}
        disabled={disabled || loading}
        style={{ width: "100%", padding: "0.625rem", border: "2px solid #2b4a84", borderRadius: 6 }}
      >
        <option value="">{placeholder}</option>
        {options.map(opt => <option key={opt.id} value={opt.id}>{opt.name}</option>)}
      </select>
      {loading && <div style={{ fontSize: "0.75rem", marginTop: 6 }}>Memuat daftar Area…</div>}
    </div>
  );
}
